import { snapshot } from 'valtio'
import { toast } from 'react-toastify'
import { recurringPaymentEditProxy } from '../modals/EditSlideOver/recurringPaymentEditProxy'
import { convertFromCentValue, convertToCentValue } from '../../../../../shared/utils/formattingUtils'
import { buildAxiosInstance, SOURCE_NAME } from '../../../../../shared/utils/apiUtils'
import {
  RecurringPaymentEditProxyFormFieldNamesEnum
} from '../modals/EditSlideOver/recurringPaymentEditProxyFormFieldNamesEnum'
import {
  type RecurringPayment,
  recurringPaymentProxy
} from '../../../../../shared/proxies/recurringPaymentProxy'

export async function executeRecurringConfigurationUpdate (): Promise<RecurringPayment | undefined> {
  try {
    recurringPaymentEditProxy.apiCallEditConfiguration.loading = true
    recurringPaymentEditProxy.apiCallEditConfiguration.error = null
    const { form: { values }, customer, customerCard, stopOnError } = snapshot(recurringPaymentEditProxy)

    const sendReceipt = !!values.email

    const response = await buildAxiosInstance().post('/api/recurring_payments/update', {
      addressOne: values[RecurringPaymentEditProxyFormFieldNamesEnum.AddressOne] || null,
      addressTwo: values[RecurringPaymentEditProxyFormFieldNamesEnum.AddressTwo] || null,
      amountCents: convertToCentValue(Number(values.amount), 'USD'),
      amountCurrencyType: 'USD',
      billingCycle: values[RecurringPaymentEditProxyFormFieldNamesEnum.BillingCycle],
      city: values[RecurringPaymentEditProxyFormFieldNamesEnum.City] || null,
      countryCode: values[RecurringPaymentEditProxyFormFieldNamesEnum.CountryCode] || 'US',
      customerCardId: customerCard?.id,
      customerId: customer?.id,
      email: sendReceipt ? values[RecurringPaymentEditProxyFormFieldNamesEnum.Email] : null,
      endDate: values[RecurringPaymentEditProxyFormFieldNamesEnum.EndDate] || null,
      invoiceNumber: values[RecurringPaymentEditProxyFormFieldNamesEnum.InvoiceNumber],
      nextPaymentDate: values[RecurringPaymentEditProxyFormFieldNamesEnum.StartDate],
      notes: values[RecurringPaymentEditProxyFormFieldNamesEnum.Notes],
      postalCode: values[RecurringPaymentEditProxyFormFieldNamesEnum.PostalCode] || null,
      recurringPaymentId: recurringPaymentProxy.recurringPayment?.id,
      sourceName: SOURCE_NAME,
      state: values[RecurringPaymentEditProxyFormFieldNamesEnum.State] || null,
      stopOnError
    })
    if (response.data.error) {
      recurringPaymentProxy.skipApiCall.error = response.data.error
      toast.error('There was an error updating the recurring charge')
    } else {
      const recentTxn: RecurringPayment = response.data?.data?.recurringPayment ?? {}

      recentTxn.amountCents = convertFromCentValue(recentTxn.amountCents, recentTxn.amountCurrencyType)
      recentTxn.totalAmountChargedCents = convertFromCentValue(recentTxn.totalAmountChargedCents, recentTxn.totalAmountChargedCurrencyType)

      recurringPaymentProxy.recurringPayment = recentTxn

      toast.success('Payment configuration successfully updated')
      return recentTxn
    }
  } catch (e) {
    if (e instanceof Error) {
      recurringPaymentEditProxy.apiCallEditConfiguration.error = e.message
    }
  } finally {
    recurringPaymentEditProxy.apiCallEditConfiguration.loading = false
  }
}
